// extracted by mini-css-extract-plugin
export default {"base":"SideNote-module--base--22bf0"};